"use client";
import type { Route } from "next";
import Link from "next/link";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu";
import type { ProductCategory } from "@/utils/routes";
import ListItem from "./list-item";

export default function DesktopNav({
  memoizedCategories,
  SUPPORT_LINKS,
}: {
  memoizedCategories: Array<{
    category: ProductCategory;
    url: string;
    displayName: string;
    description: string;
  }>;
  SUPPORT_LINKS: { title: string; href: string }[];
}) {
  return (
    <NavigationMenu>
      <NavigationMenuList>
        <NavigationMenuItem>
          <NavigationMenuTrigger className="px-1 font-bold font-heading">
            Shop
          </NavigationMenuTrigger>
          <NavigationMenuContent>
            <ul className="grid w-[420px] gap-4 p-5 md:w-[520px] md:grid-cols-2 lg:w-[620px]">
              {memoizedCategories.map(
                ({ category, url, displayName, description }) => (
                  <ListItem href={url} key={category} title={displayName}>
                    {description}
                  </ListItem>
                )
              )}
            </ul>
          </NavigationMenuContent>
        </NavigationMenuItem>

        <NavigationMenuItem>
          <NavigationMenuLink asChild className={navigationMenuTriggerStyle()}>
            <Link className="px-1 font-bold font-heading" href="/shop">
              All Products
            </Link>
          </NavigationMenuLink>
        </NavigationMenuItem>

        <NavigationMenuItem>
          <NavigationMenuTrigger className="px-1 font-bold font-heading">
            Support
          </NavigationMenuTrigger>
          <NavigationMenuContent>
            <ul className="grid w-[220px] gap-4 p-5">
              {SUPPORT_LINKS.map((link) => (
                <li key={link.title}>
                  <NavigationMenuLink asChild>
                    <Link
                      className="block select-none space-y-1 rounded-md p-3.5 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                      href={link.href as Route}
                    >
                      <div className="font-bold text-sm leading-none tracking-tight">
                        {link.title}
                      </div>
                    </Link>
                  </NavigationMenuLink>
                </li>
              ))}
            </ul>
          </NavigationMenuContent>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
}
